import React from 'react';

const DietaryLabel = ({ preference, size = 'sm' }) => {
  const getLabelConfig = (pref) => {
    switch (pref) {
      case 'veg':
        return {
          text: 'Veg',
          bgColor: 'bg-green-400',
          textColor: 'text-white',
          borderColor: 'border-green-500',
          icon: '🟢'
        };
      case 'non-veg':
        return {
          text: 'Non-Veg',
          bgColor: 'bg-red-400',
          textColor: 'text-white',
          borderColor: 'border-red-500',
          icon: '🔴'
        };
      case 'egg':
        return {
          text: 'Egg',
          bgColor: 'bg-yellow-500',
          textColor: 'text-white',
          borderColor: 'border-yellow-500',
          icon: '🟡'
        };
      default:
        return {
          text: 'Unknown',
          bgColor: 'bg-gray-500',
          textColor: 'text-white',
          borderColor: 'border-gray-500',
          icon: '⚪'
        };
    }
  };

  const config = getLabelConfig(preference);
  
  const sizeClasses = {
    xs: 'px-1 py-0.5 text-xs',
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const iconSizeClasses = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  return (
    <div className={`inline-flex items-center gap-1 ${config.bgColor} ${config.textColor} rounded-full font-medium ${sizeClasses[size]} border ${config.borderColor}`}>
      <span className="text-xs">{config.icon}</span>
      <span>{config.text}</span>
    </div>
  );
};

export default DietaryLabel; 